"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwiperContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _Swiper = require("b2b-components/core/components/Gallery/Gallery/Body/ItemList/Swiper/Swiper");
var _swiper = _interopRequireWildcard(require("swiper"));
var _Arrow = require("../Arrow");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SwiperContainer = _ref => {
  let {
    onManufacturerLogoClick,
    Image360ItemComponent,
    ImageItemComponent,
    VideoItemComponent,
    ...originalProps
  } = _ref;
  const {
    currentItemIndex,
    currentPreviewItemIndex,
    image360,
    images,
    imageUrl,
    isMobile,
    isPreview,
    itemIndexArray,
    onItemChange,
    onItemClick,
    prevItemIndex,
    text,
    title,
    totalItemCount,
    videos,
    imageDisclaimer
  } = originalProps;
  const swiperElement = (0, _react.useRef)(null);
  const swiper = (0, _react.useRef)(null);
  const initTimeout = (0, _react.useRef)(null);
  const videoStopObjectArray = []; //eslint-disable-line react-hooks/exhaustive-deps

  const [isAutoplayDirty, setIsAutoplayDirty] = (0, _react.useState)(false);
  // the method below is necessary, to avoid appearing duplicate slides,
  // which are created by Swiper component (they don't have events handler)
  const setSlidesCorrectly = () => {
    if (swiper.current && swiper.current.isBeginning) {
      swiper.current.slideToLoop(itemIndexArray.length - 1);
    }
    if (swiper.current && swiper.current.isEnd) {
      swiper.current.slideToLoop(0);
    }
  };
  const registerVideoStopObject = videoStopObject => {
    videoStopObjectArray[videoStopObject.videoIndex] = videoStopObject.onStop;
  };
  const stopVideo = videoIndex => {
    videoStopObjectArray[videoIndex] && videoStopObjectArray[videoIndex]();
  };
  const handleManufacturerLogoClick = e => {
    e.preventDefault();
    onManufacturerLogoClick?.();
  };

  // cleaning up after Swiper component (after initialization) - handling duplicate slides
  // it has to be done directly into HTML DOM because of Swiper operations
  const handleSwiperInit = () => {
    if (!isPreview) {
      const duplicateSlides = document.querySelectorAll('.cds-Modal .swiper-slide-duplicate');
      for (const slide of duplicateSlides) {
        // remove id attributes from duplicate slides - id is used to create zoom for images
        const imageMagicZoom = slide.querySelector('.MagicZoom');
        imageMagicZoom?.removeAttribute('id');
        // remove duplicate slides (iframes) for videos
        const videoIframe = slide.querySelector('iframe');
        videoIframe?.remove();
      }
    }
  };
  const handleSwiperSlideChange = () => {
    let swiperIndex;
    if (swiper.current && (typeof swiper.current.realIndex === 'number' || typeof swiper.current.realIndex === 'string')) {
      swiperIndex = swiper.current.realIndex;
    } else {
      swiperIndex = currentItemIndex;
    }
    setSlidesCorrectly();
    const itemIndex = itemIndexArray[swiperIndex];
    if (itemIndex !== undefined) {
      onItemChange?.(itemIndex);
    }
    if (window.MagicZoom && !isPreview) {
      window.MagicZoom.stop();
      window.MagicZoom.start(`image${itemIndex}`);
    }
  };
  const handleRenderNextButton = () => {
    if (totalItemCount > 1) {
      return /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
        type: _Arrow.ARROW_TYPE.next,
        isPreview: isPreview
      });
    }
    return null;
  };
  const handleRenderPrevButton = () => {
    if (totalItemCount > 1) {
      return /*#__PURE__*/_react.default.createElement(_Arrow.Arrow, {
        type: _Arrow.ARROW_TYPE.prev,
        isPreview: isPreview
      });
    }
    return null;
  };
  const swiperParams = {
    effect: 'fade',
    initialSlide: itemIndexArray.indexOf(currentItemIndex) !== -1 ? itemIndexArray.indexOf(currentItemIndex) : 0,
    loop: true,
    modules: [_swiper.EffectFade, _swiper.Navigation],
    navigation: {
      nextEl: `.${_Arrow.ARROW_CLASS_NAME_NEXT}`,
      prevEl: `.${_Arrow.ARROW_CLASS_NAME_PREV}`
    },
    on: {
      init: handleSwiperInit,
      slideChange: handleSwiperSlideChange
    },
    renderNextButton: handleRenderNextButton,
    renderPrevButton: handleRenderPrevButton,
    simulateTouch: false,
    speed: 0,
    Swiper: _swiper.default
  };
  let itemIndex = 0;
  const swiperItems = [...(images ? images.map(image => /*#__PURE__*/_react.default.createElement(ImageItemComponent, {
    image: image,
    imageUrl: imageUrl,
    isPreview: isPreview,
    onClick: onItemClick,
    title: title,
    isCurrentImage: currentItemIndex === itemIndexArray[itemIndex],
    itemIndex: itemIndexArray[itemIndex],
    key: itemIndex++,
    text: text,
    imageDisclaimer: imageDisclaimer
  })) : []), ...(image360 ? [/*#__PURE__*/_react.default.createElement(Image360ItemComponent, {
    image360: image360,
    imageUrl: imageUrl,
    isPreview: isPreview,
    onClick: onItemClick,
    title: title,
    key: itemIndex++,
    imageDisclaimer: imageDisclaimer
  })] : []), ...(videos ? videos.map(video => /*#__PURE__*/_react.default.createElement(VideoItemComponent, {
    isAutoplay: !isMobile && !isAutoplayDirty && itemIndex === currentItemIndex && currentItemIndex === currentPreviewItemIndex,
    onClick: onItemClick,
    title: title,
    isPreview: isPreview,
    itemIndex: itemIndexArray[itemIndex],
    video: video,
    key: itemIndex++,
    registerVideoStopObject: registerVideoStopObject,
    setIsAutoplayDirty: setIsAutoplayDirty,
    imageDisclaimer: imageDisclaimer
  })) : [])];
  (0, _react.useEffect)(() => {
    const activeItemIndex = itemIndexArray.indexOf(currentItemIndex);
    const swiperIndex = swiper.current?.realIndex || 0;
    !isPreview && prevItemIndex && stopVideo(prevItemIndex);
    if (
    // mobileMenu tabs change
    swiper.current && !swiper.current.destroyed && activeItemIndex !== swiperIndex) {
      swiper.current?.slideToLoop?.(activeItemIndex);
    }
  }, [currentItemIndex, isMobile, isPreview, prevItemIndex]);
  (0, _react.useEffect)(() => {
    if (initTimeout.current) {
      clearTimeout(initTimeout.current);
    }
    initTimeout.current = setTimeout(() => {
      const swiperInstance = swiperElement.current?.swiper;
      if (!swiper.current) {
        swiper.current = swiperInstance;
      }
    }, 0);
    return () => {
      if (initTimeout.current) {
        clearTimeout(initTimeout.current);
      }
    };
  });
  return /*#__PURE__*/_react.default.createElement(_Swiper.Swiper, (0, _extends2.default)({}, originalProps, {
    onManufacturerLogoClick: handleManufacturerLogoClick,
    registerVideoStopObject: registerVideoStopObject,
    swiperElement: swiperElement,
    swiperItems: swiperItems,
    swiperParams: swiperParams
  }));
};
exports.SwiperContainer = SwiperContainer;
//# sourceMappingURL=SwiperContainer.js.map